import React from 'react'
import moment from 'moment'
import {
  StepContainer,
  Title,
} from 'Components/SharedComponents/Surveys/Surveys.styled'
import { ActionElementType } from 'Components/SharedComponents/Surveys/constants'
import { NextActions } from 'Components/SharedComponents/Surveys/NextActions/NextActions'
import { ButtonAction } from 'Components/SharedComponents/Surveys/types'
import { HandleActionArgs, PartialUserSurvey } from '../types'
import { CheckInWizardStep } from '../constants'
import { PriorityReview } from './PriorityReview'

type ReviewPreviousPrioritiesProps = {
  onAnyAction: ({ nextStep, callback }: HandleActionArgs) => void
  userSurvey: PartialUserSurvey
}

export const ReviewPreviousPriorities = ({
  onAnyAction,
  userSurvey,
}: ReviewPreviousPrioritiesProps) => {
  const nextActions: ButtonAction[] = [
    {
      label: 'Next',
      path: CheckInWizardStep.REVISIT_YOUR_BASELINES,
      saveUserState: true,
      type: ActionElementType.BUTTON,
    },
  ]

  const surveyDate = moment.utc(userSurvey.completedAt).format('MM/DD/YYYY')

  return (
    <StepContainer>
      <Title>On {surveyDate} your selection was:</Title>
      <PriorityReview userSurvey={userSurvey} />
      <NextActions nextActions={nextActions} onAnyAction={onAnyAction} />
    </StepContainer>
  )
}
